import { render, staticRenderFns } from "./FDrawer.vue?vue&type=template&id=167df9c2&scoped=true&"
import script from "./FDrawer.vue?vue&type=script&lang=ts&"
export * from "./FDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./FDrawer.vue?vue&type=style&index=0&id=167df9c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167df9c2",
  null
  
)

export default component.exports